export default __webpack_public_path__ + "static/media/avatar.3921191a.jpg";